import Input from 'components/_parts/atoms/input';
import { Hooks } from 'providers';
import { useOuterClick } from 'providers/OutsideClick';
import {
  LegacyRef, memo, MutableRefObject, useContext, useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { HIT_RESET } from 'redux/actions/auth';
import { HIT_LIST_BOARD } from 'redux/actions/board';
import { HIT_DASHBOARD } from 'redux/actions/dashboard';
import IconCustom from 'components/_parts/atoms/icon';

function FindBoard({ setIsShow, isShow }) {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    boardSw, setBoardSw, sideBar,
  } = useContext(Hooks);

  const typeStatus : { [keyword : string] : string } = {
    Private: t('board.private'),
    Public: t('board.public'),
  };

  const { listBoard } = useSelector((state) => ({
    listBoard: state?.board?.data.map((val) => ({
      label: val.name,
      value: val.board_id,
      status: typeStatus[val.visibility_status_ket],
      type: 'findboard',
    })),
  }));
  const hideRef: MutableRefObject<undefined> = useOuterClick(
    (e: PointerEvent) => {
      if (
        Boolean(e.srcElement.className.length)
        && !e.srcElement.className.includes('board-switcher')
      ) {
        setIsShow(false);
      }
    },
  );
  const dispatch = useDispatch();
  const changeBoardId = (e) => {
    localStorage.setItem('board_id', e.value);
    localStorage.setItem('board_name', e.label);
    dispatch({
      type: HIT_DASHBOARD,
      payload: {
        board_id: e.value,
      },
    });
    dispatch({
      type: HIT_RESET,
      payload: 'jobdesc',
    });
    history.push('/dashboard');
    setBoardSw(e.value);
    setIsShow(false);
  };
  const boardId = localStorage.getItem('board_id');
  useEffect(() => {
    if (sideBar) {
      dispatch({
        type: HIT_LIST_BOARD,
        payload: {
          member_id: boardId,
        },
      });
    }
  }, [boardId, sideBar]);

  return (
    <div
      className={`findboard ${isShow ? '' : 'd-none'} ${sideBar ? '' : 'minimizeFindBoard'}`}
      ref={
        hideRef as MutableRefObject<undefined> &
        (LegacyRef<HTMLDivElement> | undefined)
      }
    >
      <div className="findboard_field">
        <Input
          id="search-board"
          menuIsOpen
          value={listBoard?.filter((val: any) => boardSw?.includes(val.value))}
          classNamePrefix="react-select-fte"
          type="dropdown-windowed"
          placeholder={t('side_bar.find_board')}
          options={listBoard}
          onChange={changeBoardId}
        />
      </div>
      <div className="findboard_info">
        <IconCustom
          typeIcon="export"
          style={{ color: '#7a96fd', strokeWidth: '2' }}
        />
        <Link to="/board" className="rBrLinks rNoDecoLink" style={{ lineHeight: '18px' }}>
          {t('side_bar.board_list')}
        </Link>
      </div>
    </div>
  );
}

export default memo(FindBoard);
